import cx from 'classnames'
import React from 'react'

import * as styles from './table.module.css'

const Table: React.FC<any> = ({ isSmall, tableClassName, ...props }) => (
  <div className={styles.container}>
    <table className={cx(styles.table, { [styles.small]: isSmall }, tableClassName)} {...props} />
  </div>
)

export default Table
